import React from "react";
import styled from "styled-components";
import { Link } from "gatsby";
import Anchor from "react-anchor-link-smooth-scroll";
import theme from "../../styles/theme";

const linkStyles = (props) => `
  font-family: ${props.bold ? "ProximaNova-SemiBold" : "ProximaNova-Regular"};
  transition-duration: ${theme.transitionDuration};

  color: ${props.color ? theme.colors[props.color] : theme.colors.black};

  :hover{  
    ${props.hovercolor ? `color: ${theme.colors[props.hovercolor]} !important;` : ``}
      cursor: ${props.to || props.href ? "pointer" : "default"};
  }

  ${
		props.caps
			? `
    color: ${theme.colors.grayscale.main};
    font-family: ProximaNova-Semibold;
    font-size: 14px;
    line-height: 19px;
    text-transform: uppercase;
    letter-spacing: .8px;
    :after {
      ${props.noCapsArrow ? `` : `content: "→";`}
      padding-left: 5px;
    }

  `
			: ``
	}


`;

const InternalLink = styled(Link)((props) => linkStyles(props));

const AnchorLink = styled(Anchor)((props) => linkStyles(props));

const GeneralLink = styled(Link)((props) => linkStyles(props));

export default ({ children, to, anchorLink, caps, openInNewTab, ...props }) => {
	// first, see if to is undefined (this is for cards that link but cause onClick action instead)
	if (to === undefined && !anchorLink) {
		return <span {...props}>{children}</span>;
	}

	// then, check to see if is a link to home page:
	const homePageLink = to === "/";
	// then, see if to is slug (with no slashes):
	const isSlug = /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(to);
	if (isSlug) {
		to = `/${to}/`;
	}
	// next, test to see if 'www.submittable.com' is at the beginning of the link, then strip the slug:
	const containsWWW = /^http(|s)\:\/\/www\.submittable\.com/.test(to);
	// make sure we're not directly linking to assets (.pdf, .doc, etc.)
	const isFile = /.+\.(pdf|mp3|mp4|doc|png)$/.test(to);
	if (containsWWW && !isFile) {
		to = to.slice(to.indexOf(".com") + 4, to.length);
	}
	// next, test to see if there is no trailing slash:
	if (
		!isFile &&
		to[0] === "/" &&
		to[to.length - 1] !== "/" &&
		to.indexOf("#") < 0 &&
		to.indexOf("?") < 0
	) {
		to = `${to}/`;
	}
	// finally test if above treatment has turned it into an internal link:
	const isInternalLink =
		homePageLink || (to.indexOf("#") > 0 && to[0] === "/") || /^\/.*\/$/.test(to);

	// add url parameters if they exist:
	if (typeof window !== "undefined") {
		if (window.location.search && isInternalLink) {
			to = `${to}${window.location.search}`;
		}
	}
	if (anchorLink) {
		return (
			<AnchorLink href={anchorLink} offset={props.offset || 100} caps={caps ? 1 : 0} {...props}>
				{children}
			</AnchorLink>
		);
	}
	if (isInternalLink && !openInNewTab) {
		return (
			<InternalLink to={to} caps={caps ? 1 : 0} {...props}>
				{children}
			</InternalLink>
		);
	}
	return (
		<GeneralLink href={to} target="_blank" rel="noopener noreferrer" caps={caps ? 1 : 0} {...props}>
			{children}
		</GeneralLink>
	);
};
